import Icon from '@/components/ui/AppIcon';

interface StatsCardProps {
  title: string;
  value: string | number;
  subtitle: string;
  icon: string;
  trend?: {
    value: number;
    isPositive: boolean;
  };
  color?: 'primary' | 'secondary' | 'accent' | 'success';
}

const StatsCard = ({
  title,
  value,
  subtitle,
  icon,
  trend,
  color = 'primary',
}: StatsCardProps) => {
  const getColorClasses = () => {
    switch (color) {
      case 'secondary':
        return 'bg-secondary/10 text-secondary';
      case 'accent':
        return 'bg-accent/10 text-accent';
      case 'success':
        return 'bg-success/10 text-success';
      default:
        return 'bg-primary/10 text-primary';
    }
  };

  return (
    <div className="p-6 glass hover:shadow-warm transition-smooth">
      <div className="flex items-start justify-between mb-4">
        <div className={`p-3 rounded-lg ${getColorClasses()}`}>
          <Icon name={icon as any} size={24} />
        </div>
        {trend && (
          <div
            className={`flex items-center gap-1 px-2 py-1 rounded-full text-xs font-caption font-medium ${
              trend.isPositive
                ? 'bg-success/10 text-success' :'bg-error/10 text-error'
            }`}
          >
            <Icon
              name={trend.isPositive ? 'ArrowUpIcon' : 'ArrowDownIcon'}
              size={12}
            />
            <span>{Math.abs(trend.value)}%</span>
          </div>
        )}
      </div>
      <div>
        <h3 className="text-3xl font-heading font-semibold text-foreground mb-1">
          {value}
        </h3>
        <p className="text-sm font-caption font-medium text-muted-foreground mb-1">
          {title}
        </p>
        <p className="text-xs font-caption text-muted-foreground">{subtitle}</p>
      </div>
    </div>
  );
};

export default StatsCard;